import { OrderHistoryProps, OrderHistoryEditorProps } from './OrderHistory.types';

/**
 * 기존 데이터 형식을 새로운 형식으로 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 새로운 컴포넌트용 props
 */
export function adaptOrderHistoryProps(originalProps: any): OrderHistoryProps {
  // 기본값 설정 (빈 객체로 초기화)
  const originalContent = originalProps?.content || {};
  const originalData = originalProps?.data || {};
  const originalComponentProps = originalProps?.componentProps || {};
  
  // 스타일 병합 (깊은 복사로 병합)
  const style = {
    ...(originalProps?.style || {}),
    ...(originalComponentProps?.style || {})
  };
  
  // 인라인 스타일과 CSS 클래스 통합
  if (originalProps.defaultStyle) {
    Object.assign(style, originalProps.defaultStyle);
  }

  // className 설정 - 여러 속성 경로에서 병합
  const className = originalProps?.className || 
                    originalComponentProps?.className || 
                    "order-history-wrapper padding-tb-40";

  // 컴포넌트 속성 값 추출
  const title = originalComponentProps?.title || 
                originalContent?.title ||
                originalProps?.title || 
                '주문 내역';

  const emptyText = originalComponentProps?.emptyText || 
                   originalContent?.emptyText ||
                   originalProps?.emptyText || 
                   '주문 내역이 없습니다.';

  // isPreview 값 추출
  const isPreview = originalProps?.isPreview ?? false;

  // 변환된 props 반환
  const adaptedProps: OrderHistoryProps = {
    content: { 
      ...originalContent,
      title,
      emptyText
    },
    style,
    className,
    data: originalData,
    componentProps: {
      ...originalComponentProps,
      title,
      emptyText,
      className
    },
    id: originalProps?.id || '',
    isPreview,
    itemsPerPage: originalProps?.itemsPerPage || 10
  };

  // 원본 props의 모든 속성 중 이미 처리한 속성 제외하고 나머지 복사
  const excludeKeys = ['content', 'style', 'className', 'data', 'componentProps', 'id', 'isPreview', 'itemsPerPage'];
  
  Object.keys(originalProps).forEach(key => {
    if (!excludeKeys.includes(key)) {
      adaptedProps[key] = originalProps[key];
    }
  });

  return adaptedProps;
}

/**
 * 에디터용 데이터 형식 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 에디터 컴포넌트용 props
 */
export function adaptOrderHistoryEditorProps(originalProps: any): OrderHistoryEditorProps {
  // 기본 props 변환 사용
  const adaptedProps = adaptOrderHistoryProps(originalProps) as OrderHistoryProps;
  
  // 에디터 관련 추가 props
  return {
    ...adaptedProps,
    isSelected: originalProps.isSelected || false,
    isPreview: originalProps.isPreview || false,
    viewMode: originalProps.viewMode || 'pc',
    updateComponent: originalProps.updateComponent || (() => {})
  };
} 